import * as actionTypes from '../actions/actionTypes'

export default function activityReducer(state = {}, action) {
   switch (action.type) {
      case actionTypes.SET_OWN_ACTIVTY_DATA:
         return action.payload
      default:
         return state
   }
}
